import React, { Component } from 'react'
import { Arrow } from 'react-konva'
import { KonvaEventObject } from 'konva/lib/Node'
import { ArrowElement as ArrowElementData } from '../../../views/LabelBuilder/LabelBuilder.slice'

interface Props {
    element: ArrowElementData
    onClick: (event: KonvaEventObject<MouseEvent>) => void
    onTransform: (event: KonvaEventObject<MouseEvent>) => void
    onDrag: (event: KonvaEventObject<DragEvent>) => void
    onRightClick: (event: KonvaEventObject<PointerEvent>) => void
}

export default class ArrowElement extends Component<Props> {
  render () {
    const { element } = this.props
    return (
      <Arrow
        opacity={element.opacity}
        points={element.points}
        fill={element.fill}
        strokeWidth={element.strokeWidth}
        id={element.id}
        key={element.id}
        draggable={true}
        stroke={element.stroke}
        x={element.x}
        y={element.y}
        scaleX={element.scaleX}
        scaleY={element.scaleY}
        rotation={element.rotation}
        onClick={this.props.onClick}
        onTransform={this.props.onTransform}
        pointerLength={element.pointerLength}
        pointerWidth={element.pointerWidth}
        onDragEnd={this.props.onDrag} 
        onContextMenu={this.props.onRightClick}/>
    )
  }
}
